import React, { Component } from 'react'
import Footer from '../footer/footer'
import Simplefooter from '../footer/simplefooter'

export default class Contact extends Component {
  render() {
    return (
      <div class="main-container-contact">
        <div id="Contact">
          <div className='contact-title'>   
            <h2 className='h2-custom h2-custom-gold'>CONTATO</h2>
          </div>
          <div class="contactBox">
            <Footer fromContact='true' className="embeddedContact"/>
          </div>
          <div class="contact-simplefooter">
            <div className="footer-father">
              <Simplefooter />
            </div>
        </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/contact/contact.js